(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waldpark-shopwelten"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('waldpark-shop-tabs')) {
    customElements.define('waldpark-shop-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this._abort) return;
        this._abort = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.mount(), { once: true, signal: this._abort.signal });
        } else {
          this.mount();
        }
      }

      mount() {
        if (!this.isConnected || this._mounted) return;
        this._mounted = true;
        this._tabs = Array.from(this.querySelectorAll('[data-wp-tab]'));
        this._panels = Array.from(this.querySelectorAll('[data-wp-panel]'));
        this._arrows = this.querySelector('[data-wp-arrows]');
        if (!this._tabs.length) return;
        const signal = this._abort.signal;
        const tablist = this.querySelector('[data-wp-tablist]');
        tablist.setAttribute('role', 'tablist');

        this._tabs.forEach((tab) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.getAttribute('href').slice(1));
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.activate(tab.dataset.wpTab);
          }, { signal });
          tab.addEventListener('keydown', (event) => {
            const index = this._tabs.indexOf(tab);
            let nextIndex;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % this._tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this._tabs.length) % this._tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = this._tabs.length - 1;
            if (nextIndex === undefined) return;
            event.preventDefault();
            this.activate(this._tabs[nextIndex].dataset.wpTab, true);
          }, { signal });
        });

        this._panels.forEach((panel) => {
          panel.setAttribute('role', 'tabpanel');
          const track = panel.querySelector('[data-wp-track]');
          track.addEventListener('scroll', () => this.updateArrows(), { passive: true, signal });
        });

        this.querySelectorAll('[data-wp-direction]').forEach((button) => {
          button.addEventListener('click', () => {
            const track = this.activeTrack();
            if (!track) return;
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            track.scrollBy({ left: Number(button.dataset.wpDirection) * track.clientWidth * 0.85, behavior: reducedMotion ? 'auto' : 'smooth' });
          }, { signal });
        });

        document.addEventListener('shopify:block:select', (event) => {
          const block = Array.from(this.querySelectorAll('[data-wp-block-id]')).find((item) => item.dataset.wpBlockId === event.detail?.blockId);
          if (!block) return;
          const panel = block.closest('[data-wp-panel]');
          this.activate(panel.dataset.wpPanel);
          block.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
        }, { signal });

        if (typeof ResizeObserver !== 'undefined') {
          this._observer = new ResizeObserver(() => this.updateArrows());
          this._observer.observe(this);
        } else {
          window.addEventListener('resize', () => this.updateArrows(), { signal });
        }

        this.setAttribute('data-enhanced', '');
        const initial = this._tabs.find((tab) => tab.dataset.wpTab === this.dataset.initialTab) || this._tabs[0];
        this.activate(initial.dataset.wpTab);
      }

      activate(key, focus = false) {
        const selected = this._tabs.find((tab) => tab.dataset.wpTab === key);
        if (!selected) return;
        this._active = key;
        this._tabs.forEach((tab) => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this._panels.forEach((panel) => { panel.hidden = panel.dataset.wpPanel !== key; });
        if (focus) {
          selected.focus({ preventScroll: true });
          selected.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }
        this.updateArrows();
      }

      activeTrack() {
        return this._panels?.find((panel) => panel.dataset.wpPanel === this._active)?.querySelector('[data-wp-track]');
      }

      updateArrows() {
        const track = this.activeTrack();
        if (!track || !this._arrows) return;
        const maxScroll = track.scrollWidth - track.clientWidth;
        this._arrows.hidden = maxScroll <= 2;
        const previous = this._arrows.querySelector('[data-wp-direction="-1"]');
        const next = this._arrows.querySelector('[data-wp-direction="1"]');
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
      }

      disconnectedCallback() {
        this._observer?.disconnect();
        this._abort?.abort();
        this._observer = null;
        this._abort = null;
        this._mounted = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
